import React from "react";
import Blogs from "../components/Blogs";
import PageFooter from "../components/PageFooter";

export default function HomePage() {
  return (
    <div>
      <Blogs />
      <PageFooter />
    </div>
  );
}
